import React, { useState } from "react";
import {
  Col,
  Typography,
  VertInput,
  VertSelect,
} from "@vertem-core/vertice-ds";
import MaskedInput from "pages/newSolicitation/components/InputMask";
import { Form } from "antd";
import { cpf as CpfValidator, cnpj as CnpjValidator } from "cpf-cnpj-validator";

const pixType = [
  {
    label: "Celular",
    value: 3,
    mask: "(99) 99999-9999",
  },
  {
    label: "CPF",
    value: 4,
    mask: "999.999.999-99",
  },
  { label: "E-mail", value: 5, mask: " ", placeholder: "exemplo@email.com" },
  {
    label: "Chave aleatória",
    value: 6,
    mask: null,
    placeholder: "Ex: 12345a67-1ab2-123a-a123-a1234b5c67de",
  },
];

const PixKey = ({ inputErrors, setError, form, setKeyPixValue }) => {
  const [selectedPixKey, setSelectedPixKey] = useState({
    label: "",
    value: 0,
    mask: "",
    pattern: null,
  });

  const validatePixKey = (rule, value) => {
    if (!value) {
      return Promise.reject(
        setError((errors) => ({
          ...errors,
          pixKey: {
            hasError: true,
            msg: "A chave pix é obrigatória",
          },
        }))
      );
    }
    const cpfRegex = /^[0-9]{11}$/;
    const cnpjRegex = /^[0-9]{14}$/;
    const phoneRegex = /^[1-9][0-9]\d{1,11}$/;
    const emailRegex =
      /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9-]+)*$/;
    const randomKeyRegex =
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

    if (phoneRegex.test(value) && selectedPixKey.label == "Celular") {
      value = `+55${value}`;
    }
    const phoneFullRegex = /^\+[1-9][0-9]\d{1,14}$/;

    if (
      (CpfValidator.isValid(value) && cpfRegex.test(value)) ||
      (CnpjValidator.isValid(value) && cnpjRegex.test(value)) ||
      phoneFullRegex.test(value) ||
      emailRegex.test(value) ||
      randomKeyRegex.test(value)
    ) {
      setKeyPixValue(value);
      return Promise.resolve(
        setError((errors) => ({
          ...errors,
          pixKey: {
            hasError: false,
            msg: " ",
          },
        }))
      );
    }

    return Promise.reject(
      setError((errors) => ({
        ...errors,
        pixKey: {
          hasError: true,
          msg: "Chave pix inválida",
        },
      }))
    );
  };

  const handleShowMaskChange = (value) => {
    const selectedType = pixType.find((type) => type.value === value);
    setSelectedPixKey(selectedType);
    form.setFieldsValue({ pixKey: "" });
  };

  return (
    <>
      <Col lg={8} md={12} sm={24} xs={24}>
        <Form.Item validateTrigger="onBlur" name="pixType" required noStyle>
          <VertSelect
            label="Selecione o tipo de chave pix"
            placeholder="Selecione o tipo de chave pix"
            options={pixType}
            onChange={handleShowMaskChange}
          />
        </Form.Item>
      </Col>

      <Col lg={12} md={12} sm={24} xs={24}>
        <Form.Item
          noStyle
          form={form}
          rules={[{ validator: validatePixKey }]}
          validateTrigger="onBlur"
          name="pixKey"
          required
        >
          {selectedPixKey.value == 5 || selectedPixKey.value == 6 ? (
            <VertInput
              placeholder={
                selectedPixKey.value == 5
                  ? selectedPixKey.placeholder
                  : "Ex: 12345a67-1ab2-123a-a123-a1234b5c67de"
              }
              status={
                inputErrors?.hasError
                  ? "error"
                  : !form.isFieldTouched("pixKey")
                  ? "default"
                  : "success"
              }
            />
          ) : (
            <MaskedInput
              placeholder={selectedPixKey.placeholder}
              mask={selectedPixKey.mask}
              label={selectedPixKey.label ? selectedPixKey.label : "Pix"}
              disabled={
                selectedPixKey.value !== 3 && selectedPixKey.value !== 4
              }
              status={
                inputErrors?.hasError
                  ? "error"
                  : !form.isFieldTouched("pixKey")
                  ? "default"
                  : "success"
              }
            />
          )}
        </Form.Item>
        {!!inputErrors.hasError ? (
          <Typography.Text type="danger">{inputErrors.msg}</Typography.Text>
        ) : (
          ""
        )}
      </Col>
    </>
  );
};

export default PixKey;
